/**
 * @module app.bdc.reports.bdcNAPOptionsCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BDCNAPOptionsCtrl($scope, $window, $rootScope, pricesService, orderService, offerService, napService) {
        var self = {};
        self.cashDrawersByTillType = {};
        self.orderForm = $rootScope.orderForm;
        self.user = $rootScope.user;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.order = $rootScope.order;
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);
        self.napService = napService;

        self.isRental = orderService.isRental(self.order.contract.contractType.code);
        self.contractMonths = orderService.getContractMonths(self.order);
        self.isOlderOffer = offerService.isOlderOffer(self.order);

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Get installation date if defined
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            return self.order.dateInstallation
                ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        /**
         * Get total price for the corresponding contract type
         * @param  {String} type : purchase or rental
         * @return {number}
         */
        self.getTotal = function (type) {
            return (
                self.order.prices.NAP.scanup[type] +
                self.order.prices.NAP.scanupOptions[type] +
                self.order.prices.NAP.tabletAndPC[type] +
                self.order.prices.NAP.printer[type] +
                self.order.prices.NAP.tpe[type] +
                self.order.prices.NAP.tillAccessories[type] +
                self.order.prices.NAP.cashDrawers[type]
            );
        };

        // Collection filters for ng-repeat options
        self.optionsFilter = function optionsFilter(option) {
            return (
                !(
                    option.optionType.code === 'NAP' ||
                    option.optionType.code === 'TPE' ||
                    option.optionType.code === 'LOGICIEL'
                ) && option.optionType.code !== 'LOGICIEL_CAISSE'
            );
        };

        self.tpeDevicesFilter = function tpeDevicesFilter(option) {
            return option.isTPEDevice && option.optionType.code === 'TPE';
        };

        self.tpeOptionsFilter = function tpeOptionsFilter(option) {
            return (
                (!option.isTPEDevice && option.optionType.code === 'TPE') ||
                (self.isOlderOffer && option.isTPEDevice && !option.isDefault && option.optionType.code === 'TPE') ||
                option.optionType.code === 'LOGICIEL'
            );
        };

        self.cashDrawerPricesFilter = function cashDrawerPricesFilter(price) {
            if (
                price.type.code === self.order.contract.contractType.code &&
                price.marketType.code === self.order.marketType.code
            ) {
                return true;
            }
        };

        // Price type filter for each group of options
        self.getTpeDevicesPriceType = function getTpeDevicesPriceType(option) {
            return self.isRental ? self.order.contract.contractType.code : 'LOC48';
        };

        self.getTpeOptionsPriceType = function getTpeOptionsPriceType(option) {
            return napService.isTpeOptionException(option.reference) ? self.order.contract.contractType.code : 'ACHAT';
        };

        self.displayTpeMonths = function displayTpeMonths(type) {
            return type === 'LOC36' ? '48' : orderService.getContractMonths(self.order);
        };

        function _isTPEDevices() {
            self.isTPEDevices = false;

            for (var i = 0; i < self.order.options.length; i++) {
                if (
                    self.order.options[i].isTPEDevice &&
                    (self.order.options[i].nbOptions > 0 || self.order.options[i].nbOffered > 0)
                ) {
                    self.isTPEDevices = true;
                }
            }
        }

        function _getCashDrawersByTillType() {
            self.order.cashDrawers.forEach(function(cashDrawer) {
                if (cashDrawer.tillType.code) {
                    self.cashDrawersByTillType[cashDrawer.tillType.code] = cashDrawer;
                }
                else {
                    self.cashDrawersByTillType['default'] = cashDrawer;
                }
            });
        }

        _isTPEDevices();
        _getCashDrawersByTillType();

        return self;
    }

    BDCNAPOptionsCtrl.$inject = [
        '$scope',
        '$window',
        '$rootScope',
        'pricesService',
        'orderService',
        'offerService',
        'napService'
    ];

    angular.module('app.bdc.reports.bdcNAPOptionsCtrl', []).controller('BDCNAPOptionsCtrl', BDCNAPOptionsCtrl);
});
